import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={item.to || item.label} className="flex items-center gap-1.5">
              {item.to && !last ? (
                <Link to={item.to} className="hover:text-gold transition-colors uppercase tracking-wider">
                  {item.label}
                </Link>
              ) : (
                <span className={`uppercase tracking-wider ${last ? "text-ink" : ""}`}>{item.label}</span>
              )}
              {!last && <ChevronRight className="h-3 w-3" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
